import { FiCreditCard, FiFileText, FiHash, FiMapPin, FiUser, FiX } from "react-icons/fi";

const sections = [
  {
    title: "Personal Information",
    icon: FiUser,
    fields: [
      ["First Name", "first_name"],
      ["Middle Name 1", "middle1_name"],
      ["Middle Name 2", "middle2_name"],
      ["Last Name", "last_name"],
      ["Email", "email"],
      ["Address", "address"],
      ["Postal Code", "postal_code"],
      ["Date of Birth", "date_of_birth"],
      ["Phone", "phone"],
      ["Gender", "gender"],
    ],
  },
  {
    title: "Education",
    icon: FiMapPin,
    fields: [
      ["School Name", "school_name"],
      ["School Country", "school_country"],
      ["School City", "school_city"],
      ["Test Center", "test_center_name"],
      ["University", "university"],
      ["University 1", "collegeName1"],
      ["University 2", "collegeName2"],
      ["University 3", "collegeName3"],
      ["University 4", "collegeName4"],
      ["University 5", "collegeName5"],
      ["Specialization 1", "specialization1"],
      ["Specialization 2", "specialization2"],
      ["Specialization 3", "specialization3"],
      ["Specialization 4", "specialization4"],
      ["Specialization 5", "specialization5"],
      ["Year", "studentyear"],
      ["School Contact", "schoolNum"],
      ["Category", "category"],
    ],
  },
  {
    title: "ACT 1",
    icon: FiFileText,
    fields: [
      ["ACT 1 ID", "act1_id"],
      ["Exam Name", "exam_name"],
      ["ACT 1 Score 1", "act1_score1"],
      ["ACT 1 Score 2", "act1_score2"],
      ["ACT 1 Score 3", "act1_score3"],
      ["ACT 1 Trial Date 1", "act1_try_date1"],
      ["ACT 1 Trial Date 2", "act1_try_date2"],
      ["ACT 1 Trial Date 3", "act1_try_date3"],
      ["ACT 1 Trial Date 4", "act1_try_date4"],
      ["ACT 1 Trial Date 5", "act1_try_date5"],
      ["ACT 1 Copies", "act1_copy_number"],
      ["ACT 1 Trial 1 ID", "act1_try1_id"],
      ["ACT 1 Trial 2 ID", "act1_try2_id"],
      ["ACT 1 Trial 3 ID", "act1_try3_id"],
      ["ACT 1 Trial 4 ID", "act1_try4_id"],
      ["ACT 1 Trial 5 ID", "act1_try5_id"],
      ["Subject 1 Name", "subject1_name"],
      ["Subject 1 Score", "subject1_score"],
      ["Subject 2 Name", "subject2_name"],
      ["Subject 2 Score", "subject2_score"],
      ["Subject 3 Name", "subject3_name"],
      ["Subject 3 Score", "subject3_score"],
      ["Subject 4 Name", "subject4_name"],
      ["Subject 4 Score", "subject4_score"],
    ],
  },
  {
    title: "ACT 2",
    icon: FiHash,
    fields: [
      ["ACT 2 ID", "act2_id"],
      ["ACT 2 Score 1", "act2_score1"],
      ["ACT 2 Score 2", "act2_score2"],
      ["ACT 2 Score 3", "act2_score3"],
      ["ACT 2 Trial Date 1", "act2_try_date1"],
      ["ACT 2 Trial Date 2", "act2_try_date2"],
      ["ACT 2 Trial Date 3", "act2_try_date3"],
      ["ACT 2 Subject 1", "subject1"],
      ["ACT 2 Subject 2", "subject2"],
      ["ACT 2 Subject 3", "subject3"],
      ["ACT 2 Copies", "act2_copy_number"],
      ["ACT 2 Trial 1 ID", "act2_try1_id"],
      ["ACT 2 Trial 2 ID", "act2_try2_id"],
      ["ACT 2 Trial 3 ID", "act2_try3_id"],
    ],
  },
  {
    title: "Status and Finance",
    icon: FiCreditCard,
    fields: [
      ["State", "state"],
      ["Invoice Number", "invoice_number"],
      ["Another Invoice Number", "another_invoice_number"],
      ["Score Pending Comment", "score_pending"],
      ["Request Edit Comment", "request_edit"],
      ["Submit Date", "submit_date"],
      ["Request Edit Date", "request_edit_date"],
      ["Request Edit User", "request_edit_user"],
      ["Invoice Date", "invoice_date"],
      ["Invoice User", "invoice_user"],
      ["Invoice Wait Date", "invoice_wait_date"],
      ["Invoice Wait User", "invoice_wait_user"],
      ["Another Invoice Date", "another_invoice_date"],
      ["Another Invoice User", "another_invoice_user"],
      ["Score Validation Date", "score_validation_date"],
      ["Score Validation User", "score_validation_user"],
      ["Score Request Date", "score_request_date"],
      ["Score Request User", "score_request_user"],
      ["Score Pending Date", "score_pending_date"],
      ["Score Pending User", "score_pending_user"],
      ["MOHE Validation Date", "mohe_validation_date"],
      ["MOHE Validation User", "mohe_validation_user"],
      ["MOHE Date", "mohe_date"],
      ["MOHE User", "mohe_user"],
      ["Done Date", "done_date"],
      ["Done User", "done_user"],
      ["Main Amount", "total_main"],
      ["Another Amount", "another_total_main"],
      ["Amount Outside", "amount_outside"],
    ],
  },
];

// Keys where we only show entries that have a non-null/empty value
const filterNullKeys = new Set([
  "collegeName1","collegeName2","collegeName3","collegeName4","collegeName5",
  "specialization1","specialization2","specialization3","specialization4","specialization5",
  "act1_score1","act1_score2","act1_score3",
  "act1_try_date1","act1_try_date2","act1_try_date3","act1_try_date4","act1_try_date5",
  "act1_try1_id","act1_try2_id","act1_try3_id","act1_try4_id","act1_try5_id",
  "act2_score1","act2_score2","act2_score3",
  "act2_try_date1","act2_try_date2","act2_try_date3",
  "act2_try1_id","act2_try2_id","act2_try3_id",
]);

function hasValue(value) {
  return value !== null && value !== undefined && value !== "" && value !== 0;
}

function formatValue(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return value;
}

function DetailItem({ label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">{label}</p>
      <p className="mt-1 text-sm text-white break-words">{formatValue(value)}</p>
    </div>
  );
}

export default function StudentDetailsModal({ student, onClose, hideSections = [] }) {
  if (!student) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/75 px-4 py-8 backdrop-blur-md">
      <div className="relative max-h-[90vh] w-full max-w-6xl overflow-hidden rounded-[28px] border border-white/10 bg-slate-900 shadow-2xl shadow-black/50">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(37,99,235,0.16),_transparent_32%),radial-gradient(circle_at_bottom_right,_rgba(16,185,129,0.14),_transparent_28%)]" />

        <div className="relative flex items-start justify-between border-b border-white/10 px-6 py-6">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-sky-300">Student Details</p>
            <h3 className="mt-2 text-2xl font-bold text-white">{formatValue(student.full_name)}</h3>
            <div className="mt-3 flex flex-wrap gap-2 text-xs font-medium text-slate-300">
              <span className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5">Unique ID: {formatValue(student.unique_id)}</span>
              <span className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5">National ID or Passport Number: {formatValue(student.passport_number)}</span>
              <span className="rounded-full border border-emerald-400/20 bg-emerald-500/10 px-3 py-1.5 text-emerald-300">{formatValue(student.state)}</span>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-2xl border border-white/10 bg-white/[0.04] p-3 text-slate-400 transition hover:bg-white/[0.08] hover:text-white"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className="relative max-h-[calc(90vh-120px)] overflow-y-auto px-6 py-6">
          <div className="grid gap-5 xl:grid-cols-2">
            {sections.filter(s => !hideSections.includes(s.title)).map((section) => {
              const Icon = section.icon;
              return (
                <section
                  key={section.title}
                  className="rounded-3xl border border-white/10 bg-slate-950/50 p-5"
                >
                  <div className="mb-4 flex items-center gap-3">
                    <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-2.5 text-sky-300">
                      <Icon size={16} />
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-white">{section.title}</h4>
                      <p className="text-sm text-slate-400">Full student record data for this section</p>
                    </div>
                  </div>

                  <div className="grid gap-3 sm:grid-cols-2">
                    {section.fields
                      .filter(([, key]) => !filterNullKeys.has(key) || hasValue(student[key]))
                      .map(([label, key]) => (
                        <DetailItem key={key} label={label} value={student[key]} />
                      ))}
                  </div>
                </section>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}